import {
  Container,
  Stack,
  Box,
  Divider,
  Text,
  HStack,
  SimpleGrid,
  useColorModeValue,
} from "@chakra-ui/react";
import { Fade } from "react-reveal";
import { useEffect, useState } from "react";

export default function Awards({ color }) {
  const [awards, setAwards] = useState([]);

  useEffect(() => {
    fetch("/content/Awards.md")
      .then((response) => {
        if (!response.ok) throw new Error("Failed to fetch markdown content");
        return response.text();
      })
      .then((mdContent) => {
        const parsedAwards = parseAwards(mdContent);
        setAwards(parsedAwards);
      })
      .catch((error) => {
        console.error("Error fetching awards content:", error);
      });
  }, []);

  // Parse the Markdown content to extract awards
  const parseAwards = (mdContent) => {
    const awards = [];
    const lines = mdContent.split("\n");

    for (let i = 0; i < lines.length; i++) {
      if (lines[i].startsWith("- **Title:**")) {
        const title = lines[i].split(":")[1].trim();
        const description = lines[++i].split(":")[1].trim();

        awards.push({ title, description });
      }
    }

    return awards;
  };

  // Get colors for light and dark modes
  const bgColor = useColorModeValue("gray.50", "gray.800");
  const titleColor = useColorModeValue(`${color}.600`, `${color}.300`);
  const descriptionColor = useColorModeValue("gray.600", "gray.400");

  return (
    <Container maxW={"3xl"} id="awards">
      <Stack
        as={Box}
        textAlign={"center"}
        spacing={{ base: 8, md: 14 }}
        pb={{ base: 20, md: 36 }}
      >
        <Stack align="center" direction="row" px={4}>
          <HStack mx={4}>
            <Text color={`${color}.400`} fontWeight={800}>
              08
            </Text>
            <Text fontWeight={800}>Awards</Text>
          </HStack>
          <Divider orientation="horizontal" />
        </Stack>
        <SimpleGrid columns={{ base: 1, md: 2 }} spacing={10} px={4}>
          {awards.map((award, index) => (
            <Fade bottom key={index}>
              <Box
                borderWidth="1px"
                borderRadius="lg"
                overflow="hidden"
                bg={bgColor}
                shadow="md"
                p={6}
                transition="transform 0.2s"
                _hover={{ transform: "scale(1.05)" }}
              >
                <Stack spacing={4}>
                  <Text fontSize="xl" fontWeight="bold" color={titleColor}>
                    {award.title}
                  </Text>
                  <Text fontSize="sm" color={descriptionColor}>
                    {award.description}
                  </Text>
                </Stack>
              </Box>
            </Fade>
          ))}
        </SimpleGrid>
      </Stack>
    </Container>
  );
}
